import validate from "/var/www/frontend_build/node_modules/.pnpm/nuxt@3.15.4_@parcel+watcher@2.5.1_@types+node@22.13.2_db0@0.2.4_eslint@8.49.0_ioredis@5.5.0_m_jidlqizxgvh7eho5pjnjjvs4ju/node_modules/nuxt/dist/pages/runtime/validate.js";
import manifest_45route_45rule from "/var/www/frontend_build/node_modules/.pnpm/nuxt@3.15.4_@parcel+watcher@2.5.1_@types+node@22.13.2_db0@0.2.4_eslint@8.49.0_ioredis@5.5.0_m_jidlqizxgvh7eho5pjnjjvs4ju/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  manifest_45route_45rule
]
export const namedMiddleware = {
  auth: () => import("/var/www/frontend_build/.app/middleware/auth.ts")
}